var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsPreferences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.143,
    height: 40.143,
    viewBox: "0 0 40.143 40.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47926",
    "data-name": "Group 47926",
    transform: "translate(-1312.929 -393.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46559",
    "data-name": "Path 46559",
    d: "M11.929,34.786.5,37.643l2.857-8.571V3.357A2.857,2.857,0,0,1,6.214.5H34.786a2.857,2.857,0,0,1,2.857,2.857V31.929a2.857,2.857,0,0,1-2.857,2.857Z",
    transform: "translate(1313.929 394.429)",
    fill: "none",
    stroke: "#387f75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46560",
    "data-name": "Path 46560",
    d: "M6,7.786a4.286,4.286,0,1,1,4.286,4.286v2.857",
    transform: "translate(1324.143 400)",
    fill: "none",
    stroke: "#387f75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46562",
    "data-name": "Path 46562",
    d: "M7.5,10.929A.714.714,0,1,0,7.5,9.5",
    transform: "translate(1326.929 411.143)",
    fill: "none",
    stroke: "#387f75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsPreferences);
export default __webpack_public_path__ + "static/media/settings-preferences.a318e3a8583e8019df9bb556a02584c0.svg";
export { ForwardRef as ReactComponent };